module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-page"
  }, [(_vm.hasTotal) ? _c('p', {
    staticClass: "total-num"
  }, [_vm._v("共 "), _c('span', [_vm._v(_vm._s(_vm.total))]), _vm._v(" 条")]) : _vm._e(), _c('vbl-icon', {
    staticClass: "page-prev",
    class: {
      'is-disabled': !_vm.hasPrev
    },
    attrs: {
      "type": "ion-ios-arrow-left"
    },
    on: {
      "click": _vm.onPrev
    }
  }), _c('ul', {
    staticClass: "page-list"
  }, [_c('li', [_c('a', {
    staticClass: "page-link",
    class: {
      'is-current': 1 === _vm.dataCurrent
    },
    on: {
      "click": _vm.onFirst
    }
  }, [_vm._v("1")])]), (_vm.hasFirstEllipsis) ? _c('li', [_c('a', {
    staticClass: "page-ellipsis",
    on: {
      "click": _vm.onPrevMore
    }
  }, [_c('vbl-icon', {
    attrs: {
      "type": "ion-ios-arrow-left"
    }
  }), _c('vbl-icon', {
    attrs: {
      "type": "ion-ios-arrow-left"
    }
  })], 1)]) : _vm._e(), _vm._l((_vm.pagesInRange), function(page) {
    return _c('li', [_c('a', {
      staticClass: "page-link",
      class: {
        'is-current': page === _vm.dataCurrent
      },
      on: {
        "click": function($event) {
          _vm.onPage(page)
        }
      }
    }, [_vm._v("\n                " + _vm._s(page) + "\n            ")])])
  }), (_vm.hasLastEllipsis) ? _c('li', [_c('a', {
    staticClass: "page-ellipsis",
    on: {
      "click": _vm.onNextMore
    }
  }, [_c('vbl-icon', {
    attrs: {
      "type": "ion-ios-arrow-right"
    }
  }), _c('vbl-icon', {
    attrs: {
      "type": "ion-ios-arrow-right"
    }
  })], 1)]) : _vm._e(), (_vm.hasLast) ? _c('li', [_c('a', {
    staticClass: "page-link",
    class: {
      'is-current': _vm.pageCount === _vm.dataCurrent
    },
    on: {
      "click": _vm.onLast
    }
  }, [_vm._v(_vm._s(_vm.pageCount))])]) : _vm._e()], 2), _c('vbl-icon', {
    staticClass: "page-next",
    class: {
      'is-disabled': !_vm.hasNext
    },
    attrs: {
      "type": "ion-ios-arrow-right"
    },
    on: {
      "click": _vm.onNext
    }
  }), (_vm.hasPerPage) ? _c('p', {
    staticClass: "per-page"
  }, [_c('vbl-select', {
    model: {
      value: (_vm.dataPerPage),
      callback: function($$v) {
        _vm.dataPerPage = $$v
      },
      expression: "dataPerPage"
    }
  }, _vm._l((_vm.perPages), function(option) {
    return _c('vbl-option', {
      key: option,
      attrs: {
        "value": option
      }
    }, [_vm._v(_vm._s(option) + "条/页")])
  }))], 1) : _vm._e(), (_vm.hasGoPage) ? _c('p', {
    staticClass: "go-page"
  }, [_vm._v("\n        跳至 "), _c('vbl-input', {
    on: {
      "blur": _vm.onInput
    },
    model: {
      value: (_vm.goPage),
      callback: function($$v) {
        _vm.goPage = $$v
      },
      expression: "goPage"
    }
  }), _vm._v(" 页\n    ")], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0480876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblPage/src/vblPage.vue
// module id = 295
// module chunks = 0